import builderPathInit from '../../util/builder-path-init';

const { BuilderPage, getServerSideProps } = builderPathInit({
  model: 'watch-page',
  pathPrefix: 'watch',
});
export default BuilderPage;
export { BuilderPage, getServerSideProps };
